import Store from "App/Store.js";

export default serverItems => Store.dispatch({type: "basketCullItemsMissingFromServer", serverItems});
